/**
 * A library for working with verifiable credentials - vc library.
 *
 * @author David I. Lehn
 *
 * Copyright 2017-2021 Digital Bazaar, Inc.
 */
module.exports = require('./vc.js');
